module.exports = {
  'zh-CN': require('./zh-CN'),
  'en-US': require('./en-US'),
};



// WEBPACK FOOTER //
// ../src/js/language/index.js